import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faParking } from '@fortawesome/free-solid-svg-icons';
library.add(faParking);

function AllenTabContent() {
  return (
    <div className="row container">
      <CardTemp
        cardLink="/AllenAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Allen Hospital Employees Lot"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            4168 9th Avenue New York NY 10034
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Surface Lot</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Valet/Self-Park
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>260 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
      <CardTemp
        cardLink="/CrescentAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Allen Hospital Crescent Lot"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            4141 9th Avenue New York NY 10034
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Surface Lot</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days Accessible
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Valet/Self-Park
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>130 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
    </div>
  );
}
export default AllenTabContent;
